import React from "react";
import SpinCore, { SpinProps } from "antd/lib/spin";
import "./spin.less";

export const Spin: React.FC<SpinProps> = (props) => <SpinCore {...props} />;

export type { SpinProps };
